import type { Category } from '@twisto/api-cms'

import { Breadcrumbs, BreadcrumbsItem } from 'homepage/components/molecules'

import { getCrumbsFromCategories } from './helpers'

type Props = {
  category: Category
}

export const CategoryBreadcrumbs = ({ category }: Props) => {
  const categoriesCrumbs = getCrumbsFromCategories(category)

  return (
    <Breadcrumbs>
      {categoriesCrumbs.map(({ path, name }, index) => (
        <BreadcrumbsItem
          key={index}
          href={path}
          isCurrent={index === categoriesCrumbs.length - 1}
        >
          {name}
        </BreadcrumbsItem>
      ))}
    </Breadcrumbs>
  )
}
